import {Controller} from '@hotwired/stimulus'
import AppRouter from 'utils/AppRouter'

export default class extends Controller {
  static values = {
    meetingId: Number,
    circleId: Number,
    meetingType: String,
    meetingPaths: Array,
  }

  connect() {
    this.handleFrameLoad = this.handleFrameLoad.bind(this)
    this.handleRouteChange = this.handleRouteChange.bind(this)
    document.addEventListener('turbo:frame-load', this.handleFrameLoad)

    if (this.isDismissed()) {
      this.element.remove()
      return
    }

    // Orgnav navigates client-side (react-router pushState) without a
    // page-frame load; AppRouter notifies subscribers on every route change.
    AppRouter.instance.subscribe(this.handleRouteChange)
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad)
    AppRouter.instance.unsubscribe(this.handleRouteChange)
  }

  dismiss() {
    this.storeDismissal()
    this.element.remove()
  }

  // Hide rather than remove: this frame persists across page-frame navigations,
  // so the banner must come back once the user leaves the meeting page.
  handleFrameLoad(event) {
    if (event.target.id === 'page-frame')
      this.updateVisibility()
  }

  handleRouteChange() {
    this.updateVisibility()
  }

  updateVisibility() {
    this.element.hidden = this.isOnMeetingPage()
  }

  isDismissed() {
    try {
      const key = this.storageKey()
      const stored = localStorage.getItem(key)
      if (!stored)
        return false

      return JSON.parse(stored) === this.meetingIdValue
    } catch {
      return false
    }
  }

  storeDismissal() {
    try {
      localStorage.setItem(this.storageKey(), JSON.stringify(this.meetingIdValue))
    } catch {
      // localStorage unavailable
    }
  }

  storageKey() {
    return `dismissed_${this.circleIdValue}_circle_${this.meetingTypeValue}_meeting`
  }

  isOnMeetingPage() {
    const pathname = window.location.pathname

    if (this.meetingPathsValue.includes(pathname))
      return true

    if (this.meetingTypeValue === 'TacticalMeeting' && pathname.includes('orgnav/tactical_meetings'))
      return true

    return false
  }
}
